<template>
  <div class="p-y-2 p-x-3">
    <div class="layout ai-center">
      <div class="layout-item is-4 d-flex ai-center">
        <vk-icon :name="icon" :size="20" class="m-r-3"/>
        <span class="text-md text-bold">
          {{ occupation_name }}
        </span>
      </div>
      <div class="layout-item is-2">
        <div class="text-center h6">
          {{ available_pros }}
        </div>
      </div>
      <div class="layout-item is-2">
        <div :class="{ 'c-red': matches_to_find > 0 }" class="text-center h6">
          {{ matches_to_find }}
        </div>
      </div>
      <div class="layout-item is-4">
        <button
            class="btn btn-sm w-100"
            @click="goToSalesforce(occupation_name)">
          Sign up {{ buttonTag }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>

import indefinite from 'indefinite';

const ICON_MAP = {
  96: 'contract', // general contracter
  81: 'lightning', // electrician
  67: 'deck', // deck builder
  44: 'cabinet', // carpenter
  164: 'wrenchdriver', // plumber
  151: 'paintroller', // painter
  119: 'flowers', // landscaper
  101: 'toolbox', // handyman
  default: 'hammersaw',
};

export default {
  name: 'stock-report-item',
  props: {
    occupation_name: {
      type: String,
      required: true,
    },
    occupation_id: {
      type: Number,
      required: true,
    },
    matches_to_find: {
      type: Number,
      required: true,
    },
    available_pros: {
      type: Number,
      required: true,
    },
  },
  computed: {
    icon () {
      return ICON_MAP[this.occupation_id] || ICON_MAP.default;
    },
    buttonTag () {
      return indefinite(this.occupation_name);
    },
  },
  methods: {
    goToSalesforce (occupation) {
      this.$events.$emit(this.$events.PRO_SIGNUP, {
        occupation,
      });
      /* eslint-disable-next-line max-len */
      window.location.href = `${this.$runtimeConstants.SALESFORCE_BECOME_A_PRO}?source=store&STOREID=${this.$route.params.storeId}`;
    },
  },
};
</script>
